import Maze from "../../maze/Maze.js";
import Control from "./Control.js";

export default class MobControl extends Control {
	constructor(callback) {
		super(callback);
	}

	init() {

		this.startCheck()
	}

	goto(dir) {
		if (!this.enabled) {
			return;
		}

		if (dir === Maze.DIR_N) {
			this.n = -1;
		}
		if (dir === Maze.DIR_E) {
			this.e = 1;
		}
		if (dir === Maze.DIR_W) {
			this.w = -1
		}
		if (dir === Maze.DIR_S) {
			this.s = 1;
		}
		if (this.check % this.eventDivider === 0) {
			return true;
		}
	}

}